import { Channel, EscalationInterface, SessionInterface, TwilioCallStatus } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/Sessions/Sessions.Controller.ts

export class SessionsAPI {
  static async takeoverConversationOnChannel(orgId: number, userId: number, channel: Channel, memberId: number): Promise<SessionInterface> {
    return APIService.Server.put<SessionInterface>(`/sessions/org/${orgId}/user/${userId}/channel/${channel}/member/${memberId}/takeover`);
  }
  // static async takeOverSession(orgId: number, sessionId: number, memberId: number): Promise<SessionInterface> {
  //   return APIService.Server.put<SessionInterface>(`/sessions/org/${orgId}/session/${sessionId}/member/${memberId}/takeover`);
  // }
  static async endTakenOverSession(
    orgId: number,
    sessionId: number,
    memberId: number,
    escalationId?: number
  ): Promise<{ session: SessionInterface; escalation: EscalationInterface }> {
    return APIService.Server.put(`/sessions/org/${orgId}/session/${sessionId}/member/${memberId}/end-takeover`, { escalationId });
  }
  static async getActiveSessions(orgId: number, take = 100, skip = 0): Promise<SessionInterface[]> {
    return APIService.Server.get<SessionInterface[]>(`/sessions/org/${orgId}`, { take, skip });
  }
  static async getActiveSessionsForUser(orgId: number, userId: number): Promise<SessionInterface[]> {
    return APIService.Server.get<SessionInterface[]>(`/sessions/org/${orgId}/user/${userId}`);
  }
  static async getOrCreateSession(orgId: number, userId: number, channel: Channel = Channel.WEB, callSid?: string) {
    return APIService.Server.get<{ session: SessionInterface; isNew: boolean }>(`/sessions/org/${orgId}/user/${userId}/channel/${channel}`, {
      callSid
    });
  }
  static async getSessionById(orgId: number, sessionId: number) {
    return APIService.Server.get<SessionInterface>(`/sessions/org/${orgId}/session/${sessionId}`);
  }

  static async refreshSession(orgId: number, sessionId: number) {
    return APIService.Server.get<SessionInterface>(`/sessions/org/${orgId}/session/${sessionId}/refresh`);
  }
  static async getSessionByCallSid(callSid: string) {
    return APIService.Server.get<SessionInterface | null>(`/sessions/call/${callSid}`);
  }
  static async updateSession(orgId: number, sessionId: number, session: Partial<SessionInterface>) {
    return APIService.Server.put<SessionInterface>(`/sessions/org/${orgId}/session/${sessionId}`, session);
  }

  static async removeMergedSessions(
    orgId: number,
    userId: number,
    mergedInto: number,
    channel: Channel
  ): Promise<{ mergedSessions: SessionInterface[] }> {
    return APIService.Server.put<{ mergedSessions: SessionInterface[] }>(
      `/sessions/org/${orgId}/user/${userId}/channel/${channel}/merged-into/${mergedInto}`
    );
  }

  static async updateCallStatus(callSid: string, callStatus: TwilioCallStatus, callStatusBody: any): Promise<SessionInterface | null> {
    return APIService.Server.put<SessionInterface | null>(`/sessions/call/${callSid}/status/${callStatus}`, callStatusBody);
  }
}
